import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import { useParams } from "react-router";
import moment from "moment";

const PieceUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);

  //get form data
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);

  const [debitCreditList, setDebitCreditList] = useState([]);

  const [spentAccountToEdit, setSpentAccountToEdit] = useState("");

  //piece
  const [pieceLibelle, setPieceLibelle] = useState("");
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState("");
  const [pieceJournal, setPieceJournal] = useState("");
  const [debit, setDebit] = useState(0);
  const [credit, setCredit] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [invoiceSpentAccountsToDelete, setInvoiceSpentAccountsToDelete] =
    useState([]);

  const [sousCompte, setSousCompte] = useState("");
  const [btnTitle, setBtnTitle] = useState("Ajouter une transaction");
  const [hideSelect, setHideSelect] = useState(false);
  const [disableSelect, setDisableSelect] = useState(false);
  const [sousCompteCs, setSousCompteCs] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);

  const checkAccountAlreadyExist = (accountID) => {
    for (let i = 0; i < debitCreditList.length; i++) {
      if (debitCreditList[i].account_id === accountID) {
        return true;
      }
    }
    return false;
  };
  /**
   *
   * @param spentAccountId
   */
  const deleteSingleSpentAccount = (spentAccountId) => {
    for (let i = 0; i < debitCreditList.length; i++) {
      if (debitCreditList[i].account_id === spentAccountId) {
        debitCreditList.splice(i, 1);
        setInvoiceSpentAccountsToDelete([
          ...invoiceSpentAccountsToDelete,
          spentAccountId,
        ]);
      }
    }
    setDebitCreditList([...debitCreditList]);

    const successMessage = t(
      "Le compte de depense a été supprimer avec succés",
    );
    toast.success(successMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const editSingleSpentAccount = (spentAccountId) => {
    setSpentAccountToEdit(spentAccountId);
    $(".edit-single-product").css("display", "revert");
    $(".add-new-product-to-invoice-btn").css("display", "none");

    let spentAccount = debitCreditList.filter(
      (s_a) => s_a.account_id === spentAccountId,
    );
    console.log("loglog: ", spentAccount);
    setSelectedPurchaseAccount({
      value: spentAccount[0]["account_id"],
      label: spentAccount[0]["account_name"],
    });
    setDebit(spentAccount[0]["debit"]);
    setCredit(spentAccount[0]["credit"]);
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const addNewAccountToPiece = () => {
    console.log("condition: ", selectedPurchaseAccount.value);
    if (
      selectedPurchaseAccount.value === undefined ||
      (debit === 0 && credit === 0)
    ) {
      toast.error(t("Vérifier les champs obligatoire !"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      if (checkAccountAlreadyExist(selectedPurchaseAccount.value)) {
        toast.error(t("Le compte ajouter existe déja !"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        hideOffcanvas();
        let debitCreditrow = {
          account_id: selectedPurchaseAccount.value,
          account_name: selectedPurchaseAccount.label,
          debit: debit,
          credit: credit,
        };
        setDebitCreditList([...debitCreditList, debitCreditrow]);
      }
    }
  };

  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchSousCompteCs = async () => {
    await jwtInterceoptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setSousComptesCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const editSpentAccount = () => {
    if (
      selectedPurchaseAccount.value === null ||
      (debit === 0 && credit === 0)
    ) {
      toast.error("Vérifier les champs obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      hideOffcanvas();
      for (let i = 0; i < debitCreditList.length; i++) {
        if (debitCreditList[i].account_id === spentAccountToEdit) {
          debitCreditList[i].account_id = selectedPurchaseAccount.value;
          debitCreditList[i].account_name = selectedPurchaseAccount.label;
          debitCreditList[i].debit = debit === "" ? 0 : debit;
          debitCreditList[i].credit = credit === "" ? 0 : credit;
        }
        setDebitCreditList([...debitCreditList]);
      }
    }
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };

  const emptyInputs = () => {
    setSelectedPurchaseAccount([]);
    setDebit(0);
    setCredit(0);
  };

  useEffect(() => {
    $(".some-fields-are-required-to-save").css("display", "none");
    getPurchaseAccount();
    getPiece();
    fetchSousCompteCs();
    fetchSousAccounts();
  }, []);
  const getPiece = async () => {
    const response = await jwtInterceoptor
      .get(`/data/user/piece/signle/${id}`)
      .then((res) => {
        console.log("dat b : ", res.data.data[0].debit_credit);
        console.log(
          "dat a: ",
          transformDebitCreditArray(res.data.data[0].debit_credit),
        );

        setDebitCreditList(
          transformDebitCreditArray(res.data.data[0].debit_credit),
        );
        setData(res.data.data[0]);
      })
      .catch((error) => console.log(error));
  };
  /**
   *
   * @param array
   * @returns {*[]}
   */
  const transformDebitCreditArray = (array) => {
    /**
     *
     * @type {*[]}
     */
    let res = [];
    for (let i = 0; i < array.length; i++) {
      /**
       *
       * @type {{account_id: *, account_name: *, debit: (boolean|*), credit: (boolean|*)}}
       */
      let obj = {
        account_id: array[i].account_id,
        account_name: array[i].account.name + " - " + array[i].account.code,
        debit: array[i].debit,
        credit: array[i].credit,
      };
      res.push(obj);
    }
    return res;
  };
  const setData = (piece) => {
    setTotalCredit(piece.total_credit);
    setTotalDebit(piece.total_debit);
    setPieceLibelle(piece.libelle);
    setPieceJournal(piece.journal);
    setInvoiceCreatedAt(piece.created_at);
    setSousCompte(piece.debit_credit[0].account.id);
    console.log(sousCompte);
  };

  useEffect(() => {
    calcDebitCreditSummary();
  }, [debitCreditList]);

  const calcDebitCreditSummary = () => {
    let totalDebit = 0;
    let totalCredit = 0;
    for (let i = 0; i < debitCreditList.length; i++) {
      totalDebit += parseFloat(
        debitCreditList[i].debit === "" ? 0 : debitCreditList[i].debit,
      );
      totalCredit += parseFloat(
        debitCreditList[i].credit === "" ? 0 : debitCreditList[i].credit,
      );
    }
    setTotalDebit(totalDebit);
    setTotalCredit(totalCredit);
    if (totalDebit !== totalCredit) {
      toast.error(t("Veuillez vérifier l'équilibre entre le débit et crédit"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      $(".invoiceSummary").css("border", "2px solid red");
    } else {
      $(".invoiceSummary").css("border", "unset");
    }
  };

  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].name + " - " + target[i].code,
      };
      array.push(obj);
    }
    return array;
  };

  const gererEquilibrePiece = () => {
    console.log("gerer erreur ");
  };
  const getPurchaseAccount = async () => {
    // We run axios, a promise is returned
    await jwtInterceoptor
      .get(baseURL + `/data/user/accounts/${organisation.id}`)
      .then((response) => {
        setPurchaseAccounts(transformArrayToOptions(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error),
      );
  };
  const save = async (event) => {
    event.preventDefault();
    if (totalDebit !== totalCredit) {
      if (totalDebit !== totalCredit) {
        toast.error(
          t("Veuillez vérifier l'équilibre entre le débit et crédit"),
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          },
        );
        $(".invoiceSummary").css("border", "2px solid red");
      } else {
        $(".invoiceSummary").css("border", "unset");
      }
    } else {
      let isOkToSave = true;
      isOkToSave = !(
        pieceJournal === "" ||
        pieceLibelle.length === 0 ||
        debitCreditList.length === 0 ||
        invoiceCreatedAt.length === 0
      );
      if (isOkToSave) {
        const prepareObject = {
          piece_id: id,
          user_id: user.id,
          organisation_id: organisation.id,
          journal: pieceJournal,
          libelle: pieceLibelle,
          type_facture: null,
          invoice_id: null,
          pieceDebitCredits: debitCreditList,
          total_debit: totalDebit,
          total_credit: totalCredit,
          invoice_created_at: invoiceCreatedAt,
          pieceDebitCreditToDelete: invoiceSpentAccountsToDelete,
        };

        const response = await jwtInterceoptor
          .patch("/data/user/piece/update", prepareObject)
          .then((res) => {
            Swal.fire(
              t("La pièce a été modifiée avec succès"),
              t(""),
              "success",
            );
            navigate("/piece/list");
          })
          .catch((error) => console.log("error while editing", error));
      } else {
        const errorMessage = t(
          "Merci de remplir tout les champs obligatoire !",
        );
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };
  return (
    <>
      <div className="main-container container-fluid">
        <GoBack route={"/piece/list"} />
      </div>
      <div className="row">
        <ToastContainer />

        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="">
                  Journal*
                </label>
                <select
                  className="form-select"
                  onChange={(e) => {
                    if (
                      e.target.value === "Banque" ||
                      e.target.value === "Caisse"
                    ) {
                      setBtnTitle("Remplir débit/crédit du sous compte");
                      setHideSelect(true);
                    } else {
                      setBtnTitle("Ajouter une transaction");
                      setHideSelect(false);
                    }
                    console.log("hideselect", hideSelect);
                    setPieceJournal(e.target.value);
                  }}
                  value={pieceJournal}
                >
                  <option value="0">
                    {t("Selectionner le journal de la pièce")}
                  </option>
                  <option value="Operation Diverses">
                    {t("Operation Diverses")}
                  </option>
                  <option value="Report à Nouveaux">
                    {t("Report à Nouveaux")}
                  </option>
                  <option value="Banque">{t("Banque")}</option>
                  <option value="Caisse">{t("Caisse")}</option>
                </select>
              </div>
              <div
                className="form-group"
                style={{
                  display: pieceJournal === "Banque" ? "block" : "none",
                }}
              >
                <label htmlFor="sousCompte" className="">
                  Sous Compte*
                </label>
                <select
                  className="form-select"
                  id="sousCompte"
                  onChange={(e) => {
                    setSousCompte(e.target.value);
                  }}
                  value={sousCompte}
                >
                  <option value="0">selectionner un sous compte</option>
                  {sousComptes.map((account) => (
                    <option
                      selected={account.id == sousCompte}
                      value={account.id}
                    >
                      {account.code + " - " + account.name}
                    </option>
                  ))}
                </select>
              </div>
              <div
                className="form-group"
                style={{
                  display: pieceJournal === "Caisse" ? "block" : "none",
                }}
              >
                <label htmlFor="sousComptecs" className="">
                  Sous Compte*
                </label>
                <select
                  className="form-select"
                  id="sousComptecs"
                  onChange={(e) => {
                    setSousCompte(e.target.value);
                  }}
                  value={sousCompte}
                >
                  <option value="0">selectionner un sous compte</option>
                  {sousComptesCs.map((account) => (
                    <option
                      selected={account.id == sousCompte}
                      value={account.id}
                    >
                      {account.code + " - " + account.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="">
                  Libelle*
                </label>
                <input
                  type="text"
                  className={`form-control `}
                  onChange={(e) => setPieceLibelle(e.target.value)}
                  value={pieceLibelle}
                />
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="">
                  Date d’opération*
                </label>
                <input
                  type="date"
                  placeholder="nom"
                  className={`form-control `}
                  onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                  value={moment(invoiceCreatedAt).format("YYYY-MM-DD")}
                />
              </div>

              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">COMPTE</th>
                    <th scope="col">DEBIT</th>
                    <th scope="col">CREDIT</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {debitCreditList.map((item) => {
                  return (
                    <tr key={item.account_id}>
                      <td>{item.account_name}</td>
                      <td>
                        {item.debit === "" ? 0 : Number(item.debit).toFixed(2)}
                      </td>
                      <td>
                        {item.credit === ""
                          ? 0
                          : Number(item.credit).toFixed(2)}
                      </td>
                      <td>
                        <i
                          onClick={() =>
                            deleteSingleSpentAccount(item.account_id)
                          }
                          className="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() =>
                            editSingleSpentAccount(item.account_id)
                          }
                          className="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  {t("ajouter une transaction")}
                </button>
              </center>

              <div className="row">
                <div className="invoiceSummary">
                  <table>
                    <tr>
                      <td className={"invoiceSummary-base"}>Total Debit :</td>
                      <td>
                        {Number(totalDebit).toFixed(2)}{" "}
                        {organisation?.currency?.code}
                      </td>
                    </tr>
                    <tr>
                      <td className={"invoiceSummary-base"}>Total Credit :</td>
                      <td>
                        {Number(totalCredit).toFixed(2)}{" "}
                        {organisation?.currency?.code}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <br />
              <div class="card-footer">
                <div class="row">
                  <div class="col-md-12">
                    <a
                      href="javascript:void(0)"
                      className="btn btn-primary saveBtn"
                      onClick={save}
                    >
                      Enregistrer
                    </a>
                    <a
                      onClick={() => {
                        navigate(-1);
                      }}
                      className="btn btn-default float-end"
                    >
                      Annuler
                    </a>
                  </div>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div className="offcanvas-header">
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i className="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div className="offcanvas-body">
                  <form className="needs-validation" noValidate="">
                    <div className="form-row">
                      <div className="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          COMPTE*
                        </label>
                        <Select
                          value={selectedPurchaseAccount}
                          maxMenuHeight={100}
                          className={"select-article"}
                          options={purchaseAccounts}
                          onChange={(choice) => {
                            setSelectedPurchaseAccount(choice);
                          }}
                        />
                      </div>

                      <div className="col-xl-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Debit*
                          </label>
                          <input
                            type="text"
                            className={`form-control `}
                            onChange={(e) => setDebit(e.target.value)}
                            value={debit}
                            disabled={credit !== 0 && credit !== ""}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Credit*
                          </label>
                          <input
                            type="text"
                            className={`form-control `}
                            onChange={(e) => setCredit(e.target.value)}
                            disabled={debit !== 0 && debit !== ""}
                            value={credit}
                          />
                        </div>
                      </div>

                      <br />
                      <br />
                      <br />
                      <br />
                    </div>
                    <i
                      className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                      onClick={addNewAccountToPiece}
                    ></i>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={editSpentAccount}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PieceUpdate;
